
import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'

import { RouterModule } from '@angular/router'

import { Core } from '../core/core'
import { SE_CORE_MODULE_BUNDLE } from '../core/core.module'

// components:
import { SeLeftNavComponent } from './left-nav.component'
import { SeLeftNavContextComponent } from './left-nav-context/left-nav-context.component'
import { SeLeftNavFooterLinksComponent } from './left-nav-footer-links/left-nav-footer-links.component'
import { SeLeftNavFooterLogoComponent } from './left-nav-footer-logo/left-nav-footer-logo.component'
import { SeLeftNavSkeletonComponent } from './left-nav-skeleton/left-nav-skeleton.component'
import { SeLeftNavItemComponent } from './left-nav-item/left-nav-item.component'
import { SeLeftNavItemContentComponent } from './left-nav-item/left-nav-item-content.component'

// dependencies
import { SeIconModule, SE_ICON_MODULE_BUNDLE } from './../icon/icon.module'
import { SeOverlayModule, SE_OVERLAY_MODULE_BUNDLE } from './../overlay/overlay.module'
import { SeTagModule, SE_TAG_MODULE_BUNDLE } from './../tag/tag.module'
import { SeIndicatorDotModule, SE_INDICATOR_DOT_MODULE_BUNDLE } from './../indicator-dot/indicator-dot.module'
import { SeCommonAvatarModule, SE_COMMON_AVATAR_MODULE_BUNDLE } from './../common-avatar/common-avatar.module'
import { SeButtonModule, SE_BUTTON_MODULE_BUNDLE } from './../button/button.module'

// left nav services:
import { LeftNavDataService } from './left-nav-data.service'
import { LeftNavDomService } from './left-nav-dom.service'
import { LeftNavStateService } from './left-nav-state.service'
import { LeftNavMobileStyleService } from './left-nav-mobile-style.service'
import { LeftNavItemClassService } from './left-nav-item/left-nav-item-class.service'

@NgModule({
  imports: [
	CommonModule, 
    RouterModule,
    SeIconModule,
    SeOverlayModule,
    SeCommonAvatarModule,
    SeTagModule,
    SeIndicatorDotModule,
    SeButtonModule
  ],
  declarations: [
    SeLeftNavComponent,
    SeLeftNavContextComponent,
    SeLeftNavFooterLinksComponent,
    SeLeftNavFooterLogoComponent,
    SeLeftNavSkeletonComponent,
    SeLeftNavItemComponent,
    SeLeftNavItemContentComponent,
  ],
  providers: [
    LeftNavDataService,
    LeftNavDomService,
    LeftNavStateService,
    LeftNavMobileStyleService,
    LeftNavItemClassService,
  ],
  exports: [
    SeLeftNavComponent,
    SeLeftNavContextComponent,
    SeLeftNavFooterLinksComponent,
    SeLeftNavFooterLogoComponent,
    SeLeftNavSkeletonComponent,
    SeLeftNavItemComponent,
    SeLeftNavItemContentComponent,
  ]
})
export class SeLeftNavModule {}

const dependencies = [
  SE_CORE_MODULE_BUNDLE,
  SE_OVERLAY_MODULE_BUNDLE,
  SE_ICON_MODULE_BUNDLE,
  SE_TAG_MODULE_BUNDLE,
  SE_INDICATOR_DOT_MODULE_BUNDLE,
  SE_COMMON_AVATAR_MODULE_BUNDLE,
  SE_BUTTON_MODULE_BUNDLE
]
export const SE_LEFT_NAV_MODULE_BUNDLE = `${Core.ANGULAR_MODULE}.leftNav`

